export default __webpack_public_path__ + "static/media/JEETonic.e843422c4324c9c09092504dbb1f7e4d.webp";